import { runtime } from '../../../classes/runtime/Runtime';
export class MobxPrepone {
    static provideInstant({ instantFactory, modifyState, owner, context, scheduler }) {
        if (!owner.provideInstantMap)
            owner.provideInstantMap = new Map();
        const mapKey = context || 'default';
        const map = owner.provideInstantMap;
        if (map.has(mapKey)) {
            return map.get(mapKey);
        }
        if (scheduler || !runtime.runtimeMobx.areStateChangesAllowed) {
            runtime.runtimeMobx.unstableStateCount++;
            const thing = instantFactory();
            map.set(mapKey, thing);
            const scheduler_ = scheduler || runtime.runtimeScheduler.addToNextStateChange;
            scheduler_(() => {
                modifyState(thing);
                map.delete(mapKey);
                runtime.runtimeMobx.unstableStateCount--;
            });
            return thing;
        }
        const thing = instantFactory();
        modifyState(thing);
        return thing;
    }
}
